import { IGetCadastroCoresByIdUseCase } from "../../../presentation/useCases/read/get_cadastro_cores_by_id_use_case";
import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

/**
 * GetCadastroCoresByIdUseCase
 */

export class GetCadastroCoresByIdUseCase implements IGetCadastroCoresByIdUseCase {
  constructor(private readonly repository: IEquipamentoMedicaoRepository) { }

  async getCadastroCoresById(): Promise<void> { }
}
